// extracted by mini-css-extract-plugin
module.exports = {"product-matrix":"product-matrix","transition-group-wrap":"transition-group-wrap","image-active":"image-active","active":"active"};